import { render, staticRenderFns } from "./CustomTableRender.vue?vue&type=template&id=27627ffd&"
import script from "./CustomTableRender.vue?vue&type=script&lang=ts&"
export * from "./CustomTableRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports